/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_CHECKFUND_EXHAUSTED } from './actionTypes';

/**
 * Updates the details in the 'ACESFund' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchCheckfundExhaustedReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_CHECKFUND_EXHAUSTED);

/**
 * Updates the indicator of creation of details in the 'ACESFund' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchCheckfundExhaustedReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_CHECKFUND_EXHAUSTED);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchCheckfundExhaustedErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_CHECKFUND_EXHAUSTED);

const reducers = combineReducers({
  fetchCheckfundExhausted: fetchCheckfundExhaustedReducer,

  isFetchingFetchCheckfundExhausted: isFetchingFetchCheckfundExhaustedReducer,
  fetchCheckfundExhaustedError: fetchCheckfundExhaustedErrorReducer,
});

export default { reducers };
